import type { PlatformConfig } from "./types";

function joinBasePath(base: string, path: string): string {
  const normalizedBase = base.replace(/\/$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return normalizedBase ? `${normalizedBase}${normalizedPath}` : normalizedPath;
}

export function resolveLlmUrl(path: string, config: PlatformConfig): string {
  return joinBasePath(config.llmBaseUrl, path);
}

export function resolveHubUrl(path: string, config: PlatformConfig): string {
  return joinBasePath(config.hubUrl, path);
}

export function resolveIndicatorUrl(
  path: string,
  config: PlatformConfig,
): string {
  return joinBasePath(config.indicatorRuntimeBaseUrl, path);
}
